import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  level?: "h2" | "h3";
}

export default function SectionHeading({ eyebrow, title, description, action, level = "h2" }: SectionHeadingProps) {
  const Heading = level;
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="min-w-0">
        {eyebrow ? (
          <div className="mb-2 flex items-center gap-2">
            <span className="h-px w-6 bg-accent-500"></span>
            <span className="text-[11px] font-medium tracking-[0.18em] text-accent-700">{eyebrow}</span>
          </div>
        ) : null}
        <Heading className="text-xl font-semibold tracking-tight text-foreground-950 md:text-2xl">{title}</Heading>
        {description ? <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{description}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}